import { useCallback, useMemo } from 'react';
import { store } from 'redux/store';
import { useSelector } from 'react-redux';
import {
  selectMeteorologyAgroWBSequentialDVGroup,
  setGroup as setGroupCP,
} from 'redux/reducers/meteorologyAgroWBSequentialDVReducer';
import buildAccordionClickFunction from 'helper/buildAccordionClickFunction';
import useLocationGroups from '../../useLocationGroups';

export default function useGroup() {
  const { groups } = useLocationGroups();
  const selectedGroup = useSelector(selectMeteorologyAgroWBSequentialDVGroup);
  const closeAccordion = useMemo(() => buildAccordionClickFunction('group-accordion'), []);

  const setGroup = useCallback((id: number) => () => {
    store.dispatch(setGroupCP(id));
    closeAccordion();
  }, [closeAccordion]);

  return {
    selectedGroup,
    groupOptions: groups,
    setGroup,
  };
}
